import React, { useState, useEffect, useContext } from 'react';
import './WorkOrderReport.css';
import { AppInfoContext } from '../../../../../../App';
import { ClipLoader } from 'react-spinners';

const WorkOrderReport = () => {
  const [isSafari, setIsSafari] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  useEffect(() => {
    const userAgent = navigator.userAgent;

    const isSafariBrowser =
      /Safari/.test(userAgent) && !/Chrome|Chromium/.test(userAgent);
    setIsSafari(isSafariBrowser);

    const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/.test(
      userAgent
    );
    setIsMobile(isMobileDevice);
  }, []);

  const { appInformation, setAppInformation } = useContext(AppInfoContext);
  const [pdfUrl, setPdfUrl] = useState('');

  useEffect(() => {
    const fetchPdf = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(
          `${apiUrl}/reports/generate/${appInformation.workOrderReport.problemId}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/pdf',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (error) {
        console.error('Error fetching PDF:', error);
      }
    };

    fetchPdf();
  }, []);

  const closeWorkOrderReport = () => {
    setAppInformation({
      ...appInformation,
      workOrderReport: {
        modalActive: false,
        problemId: null,
      },
    });
  };

  const openReportOnMobile = () => {
    window.open(pdfUrl, '_blank');
    closeWorkOrderReport();
  };

  return (
    <div
      className="work-order-report-main-container"
      onClick={closeWorkOrderReport}
    >
      {pdfUrl ? (
        isSafari && isMobile ? (
          <div className="work-order-report-safari-container">
            <div>Odaberite opciju</div>
            <div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(pdfUrl, '_blank');
                }}
                className="work-order-report-safari-button "
              >
                Otvori
              </button>
            </div>
            <a href={pdfUrl} download>
              <button className="work-order-report-safari-button ">
                Preuzmi
              </button>
            </a>
          </div>
        ) : isMobile ? (
          <div onClick={openReportOnMobile()}></div>
        ) : (
          !isSafari && (
            <iframe
              src={pdfUrl}
              title="PDF Viewer"
              width="50%"
              height="80%"
              style={{ border: 'none' }}
            />
          )
        )
      ) : (
        <ClipLoader color={'white'} size={60} data-testid="loader" />
      )}
    </div>
  );
};

export default WorkOrderReport;
